import { Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { OutlineXIcon } from '@tempmee/react-icons';

interface IProcedurePillProps {
  label: string;
  onRemove: () => void;
}

export const ProcedurePill = ({ label, onRemove }: IProcedurePillProps) => {
  return (
    <Row
      data-testid="procedure-pill"
      data-cy="procedure-pill"
      align="center"
      gap={2}
      style={{
        backgroundColor: colors.primary[50],
        border: `1.5px solid ${colors.secondary[500]}`,
        borderRadius: 36,
        height: 38,
        padding: '0px 12px',
        animation: 'pillFadeIn 0.25s ease-out',
      }}
    >
      <Typography as="span" variant="body1" style={{ whiteSpace: 'nowrap', fontWeight: 400 }}>
        {label}
      </Typography>
      <Row
        data-testid="remove-procedure"
        data-cy="remove-procedure"
        onClick={onRemove}
        align="center"
        style={{ cursor: 'pointer' }}
      >
        <OutlineXIcon color={colors.secondary[500]} width={16} height={16} />
      </Row>
    </Row>
  );
};
